import React from 'react';
import { Box, SkeletonLoader } from '@drone-js/core';
import ContentArea from 'component/common/ContentArea/ContentArea';
import { useSelector } from 'react-redux';
import { selectCmsFromBootstrap } from 'store/slice/bootstrap';
import { CmsValue } from 'core/type/BootstrapConfig.types';

const TextSearchSingleCardLoadingPlaceholder: React.FC<{ cms: CmsValue }> = ({ cms }) => {
    return (
        <Box px="12" py="4" display="flex" flexDirection="column" justifyContent="space-between" data-testid="activities-overlay-text-search-loading-placeholder">
            <SkeletonLoader label={cms[326495]} my="4" height="15px" width="130px" />
            <SkeletonLoader label={cms[326495]} height="15px" width="200px" />
        </Box>
    );
};
TextSearchSingleCardLoadingPlaceholder.displayName = 'TextSearchSingleCardLoadingPlaceholder';

const numberOfCards = 8;
const cards = new Array(numberOfCards).fill(0).map((v, i) => i);

export const TextSearchLoadingPlaceholder: React.FC = () => {
    const cms = useSelector(selectCmsFromBootstrap);

    return (
        <ContentArea pt="16" data-testid="activities-overlay-text-search-loading-placeholder-container" mx="auto" width="100%">
            {cards.map((index) => (
                <TextSearchSingleCardLoadingPlaceholder cms={cms} key={index} />
            ))}
        </ContentArea>
    );
};
TextSearchLoadingPlaceholder.displayName = 'TextSearchLoadingPlaceholder';
